import { styled } from '@mui/material';
import { ContentWrapper } from '../../../styles/shared';

export const StyledContentWrapper = styled(ContentWrapper)(({ theme }) => ({
  marginTop: theme.spacings.unit(16),
}));

export const LocationContainer = styled('div')(({ theme }) => ({
  marginTop: theme.spacings.unit(3),
  marginBottom: theme.spacings.unit(16),
}));
